<template>
  <div class="full-bleed">
    <div
      class="btn-bg-swap bg-btn-paper-primary relative overflow-hidden rounded-t-[2rem] lg:rounded-t-[4rem] mt-[3.5rem] lg:mt-[7rem] mx-auto"
    >
      <!-- Backdrop image - centered from bottom -->
      <div
        class="absolute bottom-0 left-1/2 -translate-x-1/2 h-[90%] w-[30rem] overflow-hidden lg:inset-y-0 lg:left-0 lg:translate-x-0 lg:h-full lg:w-[40.438rem]"
        :class="UIStore.is_dark_mode ? 'opacity-[4%]' : 'opacity-20'"
      >
        <img
          src="@/assets/images/BirdLogo.png"
          alt=""
          class="h-full w-full object-cover object-top lg:object-center"
        />
      </div>

      <!-- Mobile layout: centered stacked content -->
      <div class="relative z-10 flex flex-col items-center gap-5 px-6 py-8 lg:hidden">
        <!-- Logo -->
        <img
          :src="UIStore.is_dark_mode ? phx_logo_white_text : phx_logo_black_text"
          alt="Phoenix Energy Logo"
          class="h-12"
        />

        <!-- Social buttons - wrapped -->
        <div class="flex flex-wrap items-center justify-center gap-3">
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Twitter" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Facebook" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Instagram" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Linkedin" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Youtube" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Star" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="ArrowUpRight" class="h-4 w-4" :stroke-width="2" />
            </template>
          </Button>
        </div>

        <!-- Contact CTAs -->
        <div class="flex flex-col items-center gap-1 w-full">
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Phone" class="h-4 w-4" :stroke-width="2" />
            </template>
            <template #label> Call +1 445 356 345 </template>
          </Button>
          <Button size="sm" variant="paper-primary">
            <template #icon>
              <Icon name="Phone" class="h-4 w-4" :stroke-width="2" />
            </template>
            <template #label> support@phoenixenergy.com </template>
          </Button>
        </div>
      </div>

      <!-- Desktop layout: original side-by-side -->
      <div class="hidden lg:flex justify-between h-[208px] px-[3.5rem]">
        <!-- Logo overlay -->
        <div class="absolute left-14 top-1/2 -translate-y-1/2">
          <img
            :src="UIStore.is_dark_mode ? phx_logo_white_text : phx_logo_black_text"
            alt="Phoenix Energy Logo"
            class="h-16"
          />
        </div>

        <!-- Right side content -->
        <div class="absolute right-14 top-1/2 -translate-y-1/2 flex flex-col items-end gap-4">
          <div class="flex items-center gap-2">
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Twitter" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Facebook" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Instagram" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Linkedin" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Youtube" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Star" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="ArrowUpRight" class="h-4 w-4" :stroke-width="2" />
              </template>
            </Button>
          </div>

          <div class="flex items-center gap-3">
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Phone" class="h-4 w-4" :stroke-width="2" />
              </template>
              <template #label> Call +1 445 356 345 </template>
            </Button>
            <Button size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Phone" class="h-4 w-4" :stroke-width="2" />
              </template>
              <template #label> support@phoenixenergy.com </template>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useUIStore } from "@/stores";
import { Button, Icon } from "@/components";
import phx_logo_black_text from "@/assets/images/phx_logo_black_text.png";
import phx_logo_white_text from "@/assets/images/phx_logo_white_text.png";

const UIStore = useUIStore();
</script>

<style scoped>
.full-bleed {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
</style>
